import './UserMenuInfo.less';

import clsx from 'clsx';
import { dispatch, useReframe } from 'nike-re-framejs';
import React from 'react';

import { currencyFormat } from 'nike-ui/src/common/util';
import { fireGAEvent } from '@/analytics';
import { formatCurrency } from '@/common/client';
import UserAvatar from '@/common/components/user-avatar/UserAvatar';
import i18n from '@i18n';
import { navigate } from '@/routing';
import { ACCOUNT_PROFILE, ACCOUNT_SETTINGS, MARKETING_ARTICLE, MONEY_DEPOSIT, REGISTRATION } from '@/routing/routes';
import CoinStackIcon from 'nike-ui/src/icons/svg/coin-stack-icon-sv.svg';
import NCircleIcon from 'nike-ui/src/icons/svg/n-circle-icon-sv.svg';
import { Button } from 'nike-ui/src/components/button/Button';
import GearWheelIcon from 'nike-ui/src/icons/svg/gear-wheel-icon-sv.svg';
import { accountActionAllowed$, accountAvatar$, loggedIn$ } from '@/account/subs';

function goToUserProfile(e) {
    e.preventDefault();
    fireGAEvent('Nastavenia', 'Moj ucet');
    navigate(ACCOUNT_PROFILE);
}

function goToNikeDeposit(e) {
    e.stopPropagation();
    e.preventDefault();
    fireGAEvent('Main menu', 'Moj ucet - Vklad a vyber z uctu');
    navigate(MONEY_DEPOSIT);
}

function LoyaltyPoints({ points }) {
    return (
        <div className="amount-rows nik" onClick={goToBodyArticle} data-atid="show-userPoints">
            <div className="nik">
                {<NCircleIcon />}
                <span>
                    {currencyFormat(points)} <span className="user-currency">{formatCurrency('NIK')}</span>
                </span>
            </div>
        </div>
    );
}

function MenuAmounts({ userData }) {
    return (
        <div className="amount-rows" onClick={goToNikeDeposit} data-atid="goTo-userDeposit">
            {<CoinStackIcon />}
            <span className="user-board-balance-value">
                {currencyFormat(userData.getIn(['disponible', 'money']))}{' '}
                <span className="user-currency">{formatCurrency(userData.getIn(['disponible', 'currency']))}</span>
            </span>
        </div>
    );
}
function goToBodyArticle(e) {
    e.stopPropagation();
    e.preventDefault();
    navigate(MARKETING_ARTICLE, { articleCode: 'ako-ziskat-niky' });
}
function SystemButton() {
    return (
        <div className="system-button" onClick={() => navigate(ACCOUNT_SETTINGS)}>
            <GearWheelIcon />
        </div>
    );
}

function MenuAccounts({ userData }) {
    const { subscribe } = useReframe();
    const showContractId = subscribe(accountActionAllowed$('SHOW_CONTRACT_ID'));
    const userName = userData.get('userName');
    const surName = userData.get('userSurname');
    const points = userData.getIn(['points']);
    const loginName = userData.getIn(['login']);
    const cisloZmluvy = userData.getIn(['cisloZmluvy']);
    const avatarId = subscribe(accountAvatar$);
    const loggedIn = subscribe(loggedIn$);

    return (
        <>
            <div className="user-menu-actions">
                <SystemButton />
                <UserAvatar avatarId={avatarId} canChange={loggedIn} />
            </div>

            <div className="user-menu-info">
                <div className="name-row" data-atid="goTo-userProfil" onClick={goToUserProfile}>
                    {userName} {surName}
                </div>
                {showContractId && (
                    <div className="user-info">
                        {i18n('label.cisloZmluvy')} : {cisloZmluvy}
                    </div>
                )}
                <div className="user-info">
                    {i18n('jsp.profil.label.PrihlasovacieMeno')} : {loginName}
                </div>
                <div className="balances-info">
                    <MenuAmounts userData={userData} />
                    <div className="separator" />
                    <LoyaltyPoints points={points} />
                </div>
            </div>
        </>
    );
}

function goToLogin() {
    dispatch(['login.openScreen']);
}
function goToRegistration() {
    navigate(REGISTRATION, null, { prihlasenie: undefined });
}

function LoginOrRegister() {
    return (
        <div className="user-menu-info">
            <Button label={i18n('jsp.login.Prihlasit')} primary onClick={goToLogin} />
            <Button label={i18n('login.register')} onClick={goToRegistration} />
        </div>
    );
}

function UserMenuInfo({ userData }) {
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);

    return (
        <div className={clsx('menu-user-board', { loggedIn })}>
            <div className="inner-box">{loggedIn ? <MenuAccounts userData={userData} /> : <LoginOrRegister />}</div>
        </div>
    );
}

export default UserMenuInfo;
